var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_2382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0367 0.229492H2.21476C1.17288 0.229492 0.326172 1.05606 0.326172 2.07571V23.9873C0.326172 25.0069 1.17288 25.8349 2.21476 25.8349H24.0367C25.0807 25.8349 25.9309 25.0069 25.9309 23.9873V2.07571C25.9309 1.05606 25.0807 0.229492 24.0367 0.229492Z",
    fill: "#007BB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1198 9.82811H7.92129V22.0474H4.1198V9.82811ZM6.0216 3.75391C7.23644 3.75391 8.22273 4.74057 8.22273 5.95612C8.22273 7.17199 7.23644 8.15864 6.0216 8.15864C4.8019 8.15864 3.81836 7.172 3.81836 5.95612C3.81836 4.74057 4.80189 3.75391 6.0216 3.75391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 9.8286H13.9451V11.4991H13.9971C14.5035 10.5384 15.7426 9.52539 17.5903 9.52539C21.4355 9.52539 22.1461 12.0555 22.1461 15.3464V22.0479H18.3488V16.1056C18.3488 14.6886 18.3244 12.8657 16.3754 12.8657C14.3993 12.8657 14.0978 14.4101 14.0978 16.0042V22.0479H10.3047V9.8286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_2382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6054,
    height: 25.6054,
    fill: "white",
    transform: "translate(0.326172 0.229492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.6546bfbbc7419d76dd51e37142f93065.svg";
export { ForwardRef as ReactComponent };